var _style, _polygon, _path, _path2, _polygon2, _path3, _polygon3, _defs, _mask, _polygon4, _defs2, _polygon5, _polygon6, _defs3, _polygon7, _path4, _defs4, _polygon8, _path5, _defs5, _polygon9, _path6, _defs6, _polygon10, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "270.7px",
    height: "38px",
    viewBox: "0 0 270.7 38",
    style: {
      enableBackground: "new 0 0 270.7 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_00000032625818352243551820000011626211394310233011_);fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_00000062905474443431593600000017567226557884948096_);}\n\t.st5{mask:url(#mask-2_00000046310493480950220670000007522662631172616590_);fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_00000163766076469155544710000010346992934712872107_);}\n\t.st7{mask:url(#mask-2_00000153692303354036970560000017549639038512780446_);fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000087407815297035322700000012625143314611498112_);}\n\t.st9{mask:url(#mask-2_00000106842154869915502810000001057962028366913183_);fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_00000181059213416083757510000003371765654294746552_);}\n\t.st11{mask:url(#mask-2_00000130644202601835766190000005193394746082288807_);fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n\t.st12{filter:url(#Adobe_OpacityMaskFilter_00000142867412913010300130000003808416854261599895_);}\n\t.st13{mask:url(#mask-2_00000001637646121164168510000015695807163086995893_);fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "logos_x2F_MAN_x5F_blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 1.000000)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st0",
    points: "208.9,6.9 203.3,21.2 198.5,6.9 194.7,6.9 189.9,21.2 184.3,6.9 180.2,6.9 187.7,26.4  192.3,26.4 196.6,14 200.9,26.4 205.5,26.4 213,6.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 0.127733)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st0",
    d: "M28.5,13.1L21,8.8v10.4v0.3l-3.3,2l-6.3-6.1l2.3,8.5l-3.3,2l-9.2-5.3v8.5c0,3.7,2.7,5.2,5.7,3.3 l21.7-12.5C31.7,18,31.7,14.9,28.5,13.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st0",
    d: "M17.1,15.5V6.5l-10.4-6C3.5-1.3,1,0.3,1,3.9V16l7.6,4.4l-2.3-9.7l3.6-2.1L17.1,15.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "st0",
    points: "69.7,26.3 65.7,26.3 65.7,12.9 56.3,24.1 47,12.9 47,26.3 43.1,26.3 43.1,6.8 47,6.8  47.1,6.9 56.5,18.1 65.9,6.8 69.7,6.8  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st0",
    d: "M77,17.5h15.3v-4.9c0-1.3-1.3-2.3-2.8-2.3h-9.6c-1.6,0-2.8,1.1-2.8,2.3v4.9H77z M96.2,26.3h-3.9 v-5.3H77v5.3h-3.9V12.5c0-3.1,3.1-5.7,6.8-5.7h9.6c3.6,0,6.7,2.5,6.8,5.7v13.7H96.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    className: "st0",
    points: "122.7,26.3 119,26.3 118.9,26.1 103.5,12.3 103.5,26.3 99.7,26.3 99.7,6.8 103.4,6.8  119,20.5 119,6.8 122.9,6.8 122.9,26.3  "
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 126.5,
    y: 6.8,
    width: 3.9,
    height: 19.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 126.5,
    y: 6.8,
    width: 3.9,
    height: 19.5,
    id: "mask-2_00000032625818352243551820000011626211394310233011_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000137819613774191077560000016896633774000927656_",
    className: "st2",
    points: "1,33.2 269.7,33.2 269.7,-0.3  1,-0.3  "
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    className: "st3",
    points: "126.5,26.3 130.3,26.3 130.3,6.8 126.5,6.8  "
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000134239034584521603540000017002109532678363311_",
    filterUnits: "userSpaceOnUse",
    x: 132.6,
    y: 6.9,
    width: 23.2,
    height: 19.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 132.6,
    y: 6.9,
    width: 23.2,
    height: 19.3,
    id: "mask-2_00000046310493480950220670000007522662631172616590_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000134239034584521603540000017002109532678363311_)"
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000072240772221927114310000008214202602703391124_",
    className: "st2",
    points: "1,33.2 269.7,33.2 269.7,-0.3  1,-0.3  "
  })))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    className: "st5",
    points: "146.1,26.3 142.2,26.3 142.2,10.3 132.6,10.3 132.6,6.9 155.8,6.9 155.8,10.3  146.2,10.3 146.2,26.3  "
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000055692758586948753160000016833189591780981653_",
    filterUnits: "userSpaceOnUse",
    x: 156.6,
    y: 6.8,
    width: 23.2,
    height: 19.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 156.6,
    y: 6.8,
    width: 23.2,
    height: 19.5,
    id: "mask-2_00000153692303354036970560000017549639038512780446_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000055692758586948753160000016833189591780981653_)"
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000098192067194603159670000005791840966332220324_",
    className: "st2",
    points: "1,33.2 269.7,33.2 269.7,-0.3  1,-0.3  "
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st7",
    d: "M163.4,10.1c-1.6,0-2.8,1.1-2.8,2.3v8c0,1.3,1.3,2.3,2.8,2.3h9.6c1.6,0,2.8-1.1,2.8-2.3v-8 c0-1.3-1.3-2.3-2.8-2.3H163.4z M173,26.3h-9.6c-3.7,0-6.8-2.5-6.8-5.7v-8c0-3.2,3.1-5.7,6.8-5.7h9.6c3.7,0,6.8,2.7,6.8,5.7v8 C179.8,23.7,176.7,26.3,173,26.3z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000170268215356825389970000004789700575686033572_",
    filterUnits: "userSpaceOnUse",
    x: 213.7,
    y: 6.8,
    width: 23.2,
    height: 19.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 213.7,
    y: 6.8,
    width: 23.2,
    height: 19.5,
    id: "mask-2_00000106842154869915502810000001057962028366913183_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000170268215356825389970000004789700575686033572_)"
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000121261119841310702780000014037132641718306205_",
    className: "st2",
    points: "1,33.2 269.7,33.2 269.7,-0.3  1,-0.3  "
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "st9",
    d: "M220.5,10.1c-1.6,0-2.8,1.1-2.8,2.3v8c0,1.3,1.3,2.3,2.8,2.3h9.6c1.6,0,2.8-1.1,2.8-2.3v-8 c0-1.3-1.3-2.3-2.8-2.3H220.5z M230.1,26.3h-9.6c-3.7,0-6.8-2.5-6.8-5.7v-8c0-3.2,3.1-5.7,6.8-5.7h9.6c3.7,0,6.8,2.7,6.8,5.7v8 C236.9,23.7,233.8,26.3,230.1,26.3z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000079451040938630137740000004608975721620339843_",
    filterUnits: "userSpaceOnUse",
    x: 239.8,
    y: 6.8,
    width: 23.2,
    height: 19.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 239.8,
    y: 6.8,
    width: 23.2,
    height: 19.5,
    id: "mask-2_00000130644202601835766190000005193394746082288807_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000079451040938630137740000004608975721620339843_)"
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000122001357752138871640000006360279659139547558_",
    className: "st2",
    points: "1,33.2 269.7,33.2 269.7,-0.3  1,-0.3  "
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st11",
    d: "M256.2,26.3h-9.6c-3.7,0-6.8-2.5-6.8-5.7v-8c0-3.1,2.9-5.6,6.8-5.7h9.6c3.6,0,6.7,2.5,6.8,5.7 v0.4h-4v-0.4c0-1.3-1.3-2.3-2.8-2.3h-9.6c-1.6,0-2.8,1.1-2.8,2.3v8c0,1.3,1.3,2.3,2.8,2.3h9.6c1.6,0,2.8-1.1,2.8-2.3v-0.4h3.9 v0.4C263,23.6,259.8,26.3,256.2,26.3"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000062872345421105006890000016013826827544339378_",
    filterUnits: "userSpaceOnUse",
    x: 265.4,
    y: 6,
    width: 4.3,
    height: 4.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 265.4,
    y: 6,
    width: 4.3,
    height: 4.1,
    id: "mask-2_00000001637646121164168510000015695807163086995893_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000062872345421105006890000016013826827544339378_)"
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000155134752660343687620000000965795989909855146_",
    className: "st2",
    points: "1,33.2 269.7,33.2 269.7,-0.3  1,-0.3  "
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st13",
    d: "M267,7.9h0.3c0.1,0,0.3,0,0.4-0.1s0.1-0.1,0.1-0.3c0-0.1,0-0.3-0.1-0.3s-0.1-0.1-0.4-0.1H267 V7.9z M268.2,7.5c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.1-0.3,0.3l0.7,1.1h-0.4l-0.5-0.9H267v0.9h-0.4V6.8h0.7c0.3,0,0.5,0,0.7,0.1 C268.2,7.1,268.2,7.2,268.2,7.5z M265.7,8c0,0.3,0.1,0.5,0.3,0.9c0.1,0.3,0.4,0.5,0.7,0.7c0.3,0.1,0.5,0.3,0.8,0.3 s0.5-0.1,0.8-0.3c0.3-0.1,0.5-0.4,0.7-0.7s0.3-0.5,0.3-0.9c0-0.3-0.1-0.5-0.3-0.8c-0.1-0.3-0.4-0.5-0.7-0.7 c-0.3-0.1-0.5-0.3-0.9-0.3c-0.3,0-0.5,0.1-0.8,0.3s-0.5,0.4-0.7,0.7C265.8,7.3,265.7,7.7,265.7,8z M265.4,8 c0-0.4,0.1-0.7,0.3-0.9s0.4-0.5,0.8-0.8c0.3-0.1,0.7-0.3,1.1-0.3s0.7,0.1,1.1,0.3c0.3,0.1,0.5,0.4,0.8,0.8 c0.1,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.3,0.9s-0.4,0.5-0.7,0.8c-0.3,0.1-0.7,0.3-1.1,0.3c-0.4,0-0.7-0.1-1.1-0.3 c-0.3-0.1-0.5-0.4-0.7-0.8C265.5,8.7,265.4,8.4,265.4,8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBlue);
export default __webpack_public_path__ + "static/media/MAN_blue.e0a8e239f6219b01ff006f355c62348c.svg";
export { ForwardRef as ReactComponent };